import { faPhone, faTimer } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext } from 'react'
import z from 'zod'
import { useNewCallMutation } from '~/api/mutations/action'
import { Form, InputCol, Submit } from '~/components/Form'
import { DateInput } from '~/components/Form/Input/DateInput'
import { SubmitAlignment } from '~/components/Form/Submit'
import { ButtonVariation } from '~/components/Global/Interactions/Button'
import { ToastType } from '~/components/Global/Interactions/Toast/Toast'
import { AsideAction } from '~/components/Scopes/Actions/AsideAction'
import { toast } from '~/utils'
import { AsideActionContext } from '~/utils/contextes'
import { useCloseAction } from './hooks/useCloseAction'

const formSchema = z.object({
  datetime: z.date({
    coerce: true,
    errorMap: (issue, { defaultError }) => {
      if (issue.code === 'invalid_date') {
        return { message: 'Veuillez renseigner une date valide' }
      }
      return { message: defaultError }
    }
  })
})

type FormValues = z.infer<typeof formSchema>

type CallActionProps = {
  applicantIds: number[]
}

export const CallAction = ({ applicantIds }: CallActionProps) => {
  const callCreationMutation = useNewCallMutation()
  const { setIsDirty } = useContext(AsideActionContext)
  const closeAction = useCloseAction()

  const onSubmit = async (values: FormValues) =>
    callCreationMutation.mutateAsync(
      {
        applicants: applicantIds,
        datetime: values.datetime
      },
      {
        onSuccess: () => {
          closeAction(true)
          toast(
            'Appel planifié',
            "L'appel a bien été planifié",
            ToastType.Success
          )
        }
      }
    )
  return (
    <AsideAction
      title="Planifier un appel"
      icon={faPhone}
      applicantIds={applicantIds}
    >
      <Form onSubmit={onSubmit} schema={formSchema}>
        <InputCol>
          <DateInput
            label="Date prévue"
            name="datetime"
            required
            showTime
            noPast
            onChange={() => setIsDirty(true)}
          />
          <Submit
            buttonVariation={ButtonVariation.Primary}
            submitAlignment={SubmitAlignment.Right}
            loadingText="Planification..."
            successText="Planifié !"
            onSuccessReset={false}
          >
            <FontAwesomeIcon icon={faTimer} />
            Planifier l'appel
          </Submit>
        </InputCol>
      </Form>
    </AsideAction>
  )
}
